SupportBaseTicketModel = require('./base_ticket_model')
SupportUtilsHelper = require('../helpers/utils')

class SupportCallBackPhoneNumberModel extends SupportBaseTicketModel

  initialize: ->
    SupportBaseTicketModel::initialize.apply(this, arguments)
    @getDefaultPhoneForm()
    @userName = SupportUtilsHelper.getCurrentUserFullName() || null
    @userEmail = window.currentUser?.email || null
    @phoneNumber = null

  toJSON: ->
    { isLoggedIn: window.currentUser? }

  getDefaultPhoneForm: ->
    @phoneForm =
      method_of_contact: "callMeBackOption",
      objects: [
        {
          type: "user_name",
          label: I18n.translate('js.modules.support.call_me_back_user_label'),
          required: @getRequired(),
          additional_attributes: {
            maximum_number_of_characters_or_digits: ""
          },
          value: @userName
        },
        {
          type: "email_address",
          label: I18n.translate('js.modules.support.call_me_back_email_label'),
          required: @getRequired(),
          value: @userEmail
        },
        {
          type: "phone_number",
          label: I18n.translate('js.modules.support.call_me_back_your_number'),
          required: "true"
        }
      ]

  getRequired: ->
    if window.currentUser? then false else true

module.exports = SupportCallBackPhoneNumberModel
